import React, { useMemo } from "react";
import styled, { css } from "styled-components";
import getConfig from "next/config";
import { isMobile } from "react-device-detect";
import { Row, Col, OverlayTrigger, Tooltip, Form } from "react-bootstrap";

import { hexToRGBA } from "../../../../../utils/theme";

const { publicRuntimeConfig } = getConfig();

const StyledGroup = styled(Form.Group)`
  width: 100%;

  padding-left: 0;
  padding-right: 0;
  
  input:checked,
  input:not(:checked) {
    position: absolute;
    left: -9999px;
  }

  input:checked + label,
  input:not(:checked) + label {
    display: inline-block;
    position: relative;
    padding-left: 32px;

    font-family: 'LatoRegular';
    font-size: 14px;
    line-height: 24px;
    color: ${hexToRGBA('#1B3858', 0.5)};

    cursor: pointer;
  }

  input:checked + label:before {	
    content: '';
    display: inline-block;
    position: absolute;
    left: 0px;
    top: 1px;
    background: ${`url(${publicRuntimeConfig.basePath}/icons/V2/checkbox_checked.svg)`} no-repeat center; 
    width: 22px;
    height: 22px; 
    padding: 7px;
  }

  input:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 1px;
    width: 22px;
    height: 22px;
    border: 2px solid ${hexToRGBA('#1B3858', 0.5)};
    border-radius: 2px;
    background: #FFFFFF;
  }

  .col-md-6 {
    &:nth-child(odd) {
      padding-right: 8px;
    }

    &:nth-child(even) {
      padding-left: 8px;
    }
  }

  .col-12 {
    padding-bottom: 8px;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    .col-md-6 {
      &:nth-child(odd) {
        padding-right: 15px;
      }

      &:nth-child(even) {
        padding-left: 15px;
      }
    }
  }
`;

const StyledCheck = styled(Form.Check)`

`;

const StyledLabel = styled.label`
  display: flex;
  align-items: flex-start;

  height: calc(100% - 8px);
  padding: 18px;

  border: 2px solid ${hexToRGBA('#1B3858', 0.1)};
  border-radius: 7px;

  position: relative;
  cursor: pointer;

  .title {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    font-family: 'LatoBold';
    font-size: 14px;
    line-height: 24px;
    color: ${hexToRGBA('#1B3858', 0.5)};
    text-shadow: 1px 1px 0px #FFFFFF;

    .description {
      font-family: 'LatoRegular';
      font-size: 12px;
    }
  }

  .price-badge {
    position: absolute;
    top: 6px;
    right: 10px;
    font-family: 'LatoRegular';
    font-size: 16px;
    line-height: 26px;
    color: ${hexToRGBA('#1B3858', 0.5)};
    text-shadow: 1px 1px 0px #FFFFFF;
  }

  ${({ active }) => active && css`
    border: 2px solid ${hexToRGBA('#1B3858', 0.2)};

    .title {
      color: ${hexToRGBA('#1B3858', 1)};
    }

    .price-badge {
      color: ${hexToRGBA('#1B3858', 1)};
    }
  `};
`;

function ProcessingRadioGroup({
  id,
  hint,
  options = [],
  value,
  onChange,
}) {
  const overlayTriggerProps = useMemo(() => {
    const props = {
      placement: isMobile ? "top" : "right-start",
      delay: { show: 0, hide: 0 },
      trigger: ["hover", "focus"],
      overlay: (
        <Tooltip id={`tooltip-${id}`} className="hintTooltip">
          {hint}
        </Tooltip>
      ),
    };

    if (!hint) {
      props.show = false;
    }

    return props;
  }, [id, hint]);

  return (
    <OverlayTrigger {...overlayTriggerProps}>
      <StyledGroup controlId={id}>
        <Row>
          {options.map((option, i) => (
            <Col xs={12} key={`${id}${i + 1}`}>
              <StyledLabel active={value === option.value}>
                <StyledCheck
                  id={`${id}${i + 1}`}
                  name={id}
                  inline
                  type="radio"
                  label=""
                  value={option.value}
                  checked={value === option.value}
                  onChange={onChange}
                />
                <div className="title">
                  <div className="name">
                    <span>{option.name}</span>
                  </div>
                  <div className="description">
                    <span>({option.description})</span>
                  </div>
                </div>
                <div className="price-badge">
                  <span>${option.price}</span>
                </div>
              </StyledLabel>
            </Col>
          ))}
        </Row>
      </StyledGroup>
    </OverlayTrigger>
  );
}

export default ProcessingRadioGroup;
